module.exports = __webpack_public_path__ + "img/cloudy.ad789581.svg";